import { Skeleton } from "@/components/ui/skeleton"

export function TransactionsPageSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header: title + buttons */}
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-9 w-36" />
          <Skeleton className="h-5 w-56" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-9 w-36" />
          <Skeleton className="h-9 w-36" />
        </div>
      </div>

      {/* Month navigation */}
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Skeleton className="h-9 w-9" />
        <Skeleton className="h-9 w-48" />
        <Skeleton className="h-9 w-9" />
      </div>

      {/* Summary cards */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
            key={`skeleton-summary-${i}`}
            className="rounded-xl border p-6 shadow-sm space-y-2"
          >
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-8 w-3/4" />
          </div>
        ))}
      </div>

      {/* Transaction table */}
      <div className="rounded-md border">
        <div className="flex h-12 items-center border-b px-4">
          <Skeleton className="h-4 w-full" />
        </div>
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
            key={`skeleton-row-${i}`}
            className="flex h-16 items-center space-x-4 border-b px-4 last:border-0"
          >
            <Skeleton className="h-10 w-10 rounded-full" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-3 w-1/4" />
            </div>
            <Skeleton className="h-4 w-20" />
          </div>
        ))}
      </div>
    </div>
  )
}
